import React from 'react';
import { SVG, SVGIcon } from '../../../../atoms/SVG';

type BtnIconProps = {
  svgSpriteId?: SVGIcon;
  svgClass?: string;
};

export function BtnIcon({ svgSpriteId, svgClass }: BtnIconProps) {
  if (!svgSpriteId) {
    return null;
  }
  return <SVG svgSpriteId={svgSpriteId} svgClass={svgClass || 'btn__icon'} />;
}
